export class LoadDocuments {
  static readonly type = '[Documents] Load Documents';

  constructor(
    public readonly gid?: string,
    public readonly employeeId?: string,
    public readonly managerId?: string
  ) {}
}
